import {getElement, removeActive} from "./helpers.js";
import tabs from "./tabs.js";
import {adaptiveModalContent, modalEvents} from "./modalFunctions.js";
import {dealsSlider} from "../productPage/productPageSliders.js";
import {catalogItemSlider} from "../catalogItem/catalogItem.js";
import userPersonalized from "./userPersonalized.js";

export default function userPage() {
    if (!getElement('.user-page')) return;

    if (getElement('[data-hide-password]')) {
        const passwordItem = getElement('[data-hide-password]');
        const passwordText = passwordItem.innerText;
        passwordItem.innerHTML = ''
        for (let i = 0; i < passwordText.length; i++) {
            passwordItem.insertAdjacentHTML('afterbegin', '<span></span>')
        }
    }

    if (getElement('[data-swiper="deals-section"]')) {
        dealsSlider();
        getElement('.catalog-item', true).forEach(item => {

            catalogItemSlider(item.dataset.catalogItem)
        })
    }


    if (getElement('.user-navigation__btn')) {
        getElement('.user-navigation__btn').addEventListener('click', function () {
            this.classList.toggle('active');
            this.nextElementSibling.classList.toggle('active')

        })
    }
    userPersonalized()
    getElement('[data-target-modal]', true).forEach(item => {
        if (item) {
            item.addEventListener('click', () => {
                adaptiveModalContent(getElement(`[data-user-modal="${item.dataset.targetModal}"]`).querySelector('.modal__content'))
                modalEvents(getElement(`[data-user-modal="${item.dataset.targetModal}"]`))
            });
        }
    })
}